"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const meta_item_styles_1 = require("@/components/common/meta-item/meta-item.styles");
require("@/components/common/text/semantics/paragraph");
let MetaItem = class MetaItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.layout = 'horizontal';
        this.label = '';
        this.value = '';
        this.valueSize = 'medium';
    }
    render() {
        return (0, lit_1.html) `
      <mm-paragraph color="light">${this.label}</mm-paragraph>
      <mm-paragraph size=${this.valueSize}>${this.value}</mm-paragraph>
    `;
    }
};
MetaItem.styles = [meta_item_styles_1.metaItemStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], MetaItem.prototype, "layout", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MetaItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MetaItem.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'value-size' })
], MetaItem.prototype, "valueSize", void 0);
MetaItem = __decorate([
    (0, decorators_js_1.customElement)('mm-meta-item')
], MetaItem);
exports.MetaItem = MetaItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YS1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWV0YS1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFFM0QscUZBQStFO0FBQy9FLHdEQUFxRDtBQUc5QyxJQUFNLFFBQVEsR0FBZCxNQUFNLFFBQVMsU0FBUSxnQkFBVTtJQUFqQzs7UUFFc0MsV0FBTSxHQUMvQyxZQUFZLENBQUE7UUFDYyxVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ1YsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUNlLGNBQVMsR0FBdUIsUUFBUSxDQUFBO0lBUS9GLENBQUM7SUFOQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtvQ0FDcUIsSUFBSSxDQUFDLEtBQUs7MkJBQ25CLElBQUksQ0FBQyxTQUFTLElBQUksSUFBSSxDQUFDLEtBQUs7S0FDbEQsQ0FBQTtJQUNILENBQUM7O0FBWk0sZUFBTSxHQUFHLENBQUMsaUNBQWMsQ0FBQyxDQUFBO0FBQ1c7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7d0NBQzVCO0FBQ2M7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFXO0FBQ2U7SUFBcEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLENBQUM7MkNBQXlDO0FBTmxGLFFBQVE7SUFEcEIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixRQUFRLENBY3BCO0FBZFksNEJBQVEifQ==